import { FC } from 'react';

import { ChevronRightIcon } from '@heroicons/react/outline';
import { Image } from '@shared/api/media/media.interface';
import { ShopItem } from '@shared/api/shopItem/shopItem.interface';
import { ShopItemInfo } from '@shared/api/shopItemInfo/shopItemInfo.interface';
import {
  getShopItemDisplayName,
  getShopItemImageUrl,
  getShopItemName,
} from '@shared/api/shopItem/shopItem.utils';
import { Link } from 'react-router-dom';

interface Props {
  shopItem: ShopItem<ShopItemInfo<string, Image>, string, string, Image>;
  bugoId: string;
}

export const EasyBuyShopItemCard: FC<Props> = function ({ shopItem, bugoId }: Props) {
  const name = getShopItemName(shopItem);
  const displayName = getShopItemDisplayName(shopItem);

  return (
    <Link
      to={`/flower-store/item/${shopItem._id}/checkout?bugoId=${bugoId}`}
      aria-label={`${name} ${shopItem.priceRetail.toLocaleString()}원 주문하기`}
      className="flex min-w-0 items-center gap-3 rounded-lg py-2 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gray-400"
    >
      <div className="h-24 w-24 shrink-0 min-[360px]:h-28 min-[360px]:w-28">
        <img
          src={`${process.env.REACT_APP_BUCKET_URL}/w400/${getShopItemImageUrl(
            shopItem,
          )}`}
          alt={name}
          className="h-full w-full object-contain"
        />
      </div>
      <div className="min-w-0 flex-1 py-2">
        <p className="break-words text-14 font-medium leading-5 text-gray-700">
          {displayName}
        </p>
        <p className="mt-1.5 whitespace-nowrap text-18 font-bold leading-6 text-gray-900">
          {shopItem.priceRetail.toLocaleString()}
          <span className="ml-0.5 text-14 font-medium">원</span>
        </p>
        <span className="mt-2 flex items-center gap-0.5 text-12 font-medium theme-text-main">
          주문하기
          <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" />
        </span>
      </div>
    </Link>
  );
};
